// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"faqSearch_searchContainer__2J3g2"};